module.exports = __webpack_public_path__ + "static/media/retirado.419dd322.svg";